<template>
  <div class="d-flex flex-column align-start">
    <FieldLabel :text="$t('problem_solving.measure.upload_trigger_label')" />

    <FileUpload
      v-if="isEditMode"
      class="cursor-pointer mt-2"
      input-id="measure-attachment"
      :accept="$constants.attachments.acceptedFormats.join(',')"
      :multiple="false"
      :drop="false"
      :drop-directory="false"
      @input-file="selectFile"
    >
      <Button
        color="grey"
        class="mb-5"
        icon="mdi-attachment"
        outlined
        :text="$t('problem_solving.measure.upload_trigger_text')"
        @click="selectFile"
      />
    </FileUpload>

    <span>
      <v-chip
        v-if="!isEditMode && !hasAttachments"
        disabled
        small
        class="label mt-2"
        >{{ $t('common.in_progress_status') }}</v-chip
      >
    </span>
  </div>
</template>

<script>
import FileUpload from 'vue-upload-component'

import mixin from '@/mixins/mixin.vue'
import FieldLabel from '@/components/Core/FieldLabel'
import Button from '@/components/UI/Button'

export default {
  mixins: [mixin],

  props: {
    isEditMode: {
      type: Boolean,
      required: false,
    },
    hasAttachments: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
  },

  components: {
    FileUpload,
    FieldLabel,
    Button,
  },

  methods: {
    selectFile(file) {
      if (!file) return

      if (file.size > this.$constants.attachments.maxFileSizeInBytes) {
        return this.handleMaxSizeError()
      }

      if (!this.$constants.attachments.acceptedFormats.includes(file?.type)) {
        return this.handleUnsupportedFile()
      }

      this.$emit('fileSelected', file)
    },

    handleMaxSizeError() {
      this.showError(
        this.$t('attachments.maximum_file_size', {
          maxFileSize: this.$constants.attachments.maxFileSizeInMB,
        })
      )
    },

    handleUnsupportedFile() {
      this.showError(this.$t('attachments.the_file_is_not_supported'))
    },
  },
}
</script>
